import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { apiUrl } from "../../modules/api/base";
import AppUser from "../../modules/app-user/app-user";
import { ROUTES } from "../../routes";
import usePageTitle from "../../hooks/use-page-title";
import ApiARIAAuth from "../../modules/api/aria-auth";
import useFlashMessageStore from "../../hooks/use-flash-message-store";
import LoginIntro from "../../components/common/LoginIntro";
import BasicLoader from "../../components/common/BasicLoader/BasicLoader";

const ADFS_ERROR_MESSAGE = `Your SIT account is not registered in GROW-Pro. Please contact your IWSP co-ordinator for assistance.`;

export default function PageAuth() {
  usePageTitle("Login ADFS");
  const navigate = useNavigate();
  const location = useLocation();
  const flashMessageLogin = useFlashMessageStore("alert-login-adfs");

  useEffect(() => loginAdfs(), []);

  const loginAdfs = () => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (!token) {
      onFailed("token required");
      return;
    }
    const authHeader = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(apiUrl(`/apiauth/adfs/login`), {}, authHeader)
      .then(async (res) => {
        if (res.status === 200) {
          const responseData = res.data;
          if (responseData.result === "OK") {
            const user = responseData.data;
            await AppUser.setInfo(
              Object.assign(
                {
                  lastUpdate: Date.now(),
                  id: user._id,
                  logged: true,
                  role: user.roles.length === 1 ? user.roles[0] : "",
                  token: user.authToken,
                  just_logged: true,
                  isAdfsUser: true,
                },
                user
              )
            );

            const aria_token = await ApiARIAAuth.getToken();

            if (aria_token.status) {
              await AppUser.setInfo({
                aria_token: aria_token.data.accessToken ?? "",
              });
            }

            if (user.roles.length === 1) {
              navigate(ROUTES.PORTAL_DASHBOARD);
            } else {
              navigate(ROUTES.PORTAL_SELECT_ROLE);
            }
          } else {
            // onFailed(`Login by your SIT account is failed. ${ responseData.message ?? `` }`);
            onFailed(ADFS_ERROR_MESSAGE);
          }
        } else {
          // onFailed(`Login by your SIT account is failed. Status code ${res.status}`);
          onFailed(ADFS_ERROR_MESSAGE);
        }
      })
      .catch((err) => {
        // onFailed(`Login by your SIT account is failed. ${err.message}`);
        onFailed(ADFS_ERROR_MESSAGE);
      });
  };

  const onFailed = (error: string) => {
    flashMessageLogin.setMessage({
      message: error,
      type: "danger",
    });
    setTimeout(() => navigate(ROUTES.AUTH_LOGIN), 1000);
  };

  return (
    <div className="PageAuth PageAuth--ADFS" data-comp="PageAuth">
      <div className="PA__row">
        <div className="PA__col PA__col--desc">
          <div className="PA__col--desc-inner">
            <LoginIntro />
          </div>
        </div>
        <div className="PA__col PA__col--adfs py-5">
          <BasicLoader />
        </div>
      </div>
    </div>
  );
}
